import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ShieldCheck } from "lucide-react";
import { useAuth } from "../auth";
import { formatApiError } from "../api";
import { LOGO } from "../data";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import Embers from "../components/Embers";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("services.events@outlook.fr");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bienvenue !");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Connexion impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#050505] px-5 py-12">
      <Embers density={40} />
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <img src={LOGO} alt="Logo" className="h-11 w-auto" />
          <span className="flex flex-col leading-none">
            <span className="font-head text-lg font-bold uppercase text-white">Services</span>
            <span className="text-[9px] tracking-[0.25em] text-white/60">EVENT'S MULTITECHNIQUE</span>
          </span>
        </div>
        <div className="rounded-lg border border-white/10 bg-[#0d0d0d] p-8">
          <div className="mb-6 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-white/60">
            <ShieldCheck size={14} className="text-[#ff4d4d]" /> Espace administrateur
          </div>
          <h1 className="font-head text-3xl font-semibold uppercase tracking-tight text-white">Connexion</h1>
          <p className="mt-2 text-sm font-light text-white/60">Accédez à votre tableau de bord.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-white/70">Email</Label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
                <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="border-white/10 bg-black/50 pl-9 text-white" data-testid="login-email" />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-white/70">Mot de passe</Label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
                <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="border-white/10 bg-black/50 pl-9 text-white" data-testid="login-password" />
              </div>
            </div>
            <button type="submit" disabled={busy} className="w-full rounded-full bg-brand-gradient py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] disabled:opacity-60" data-testid="login-submit">
              {busy ? "Connexion…" : "Se connecter"}
            </button>
          </form>
          <p className="mt-6 text-[11px] leading-relaxed text-white/40">
            Mot de passe initial fourni par votre équipe. Vous pourrez le modifier
            depuis les paramètres après connexion.
          </p>
        </div>
        <div className="mt-6 text-center">
          <a href="/" className="text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white">← Retour au site</a>
        </div>
      </div>
    </div>
  );
}
